import AppButton from '../../../../components/ui/AppButton';

const UpdateOwnerButton = ({ onClick }) => {
  return (
    <AppButton variant="primary" size="small" onClick={onClick}>
      ย้ายสิทธิ์
    </AppButton>
  );
};
export default UpdateOwnerButton;
